import React, { useState, useEffect } from 'react';
import { Drawer, Box, Typography, IconButton, TextField, Button, MenuItem, Divider, Autocomplete } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const statuses = [
  'Initial Outreach Pending', 'Followup Pending', 'Closing Outreach Pending', 'Outreach Completed', 
  'Response Received', 'Rejected', 'Positive Outcome', 'Negative Outcome'
];

const priorities = [1, 2, 3];

const EditSidebar = ({ open, onClose, decisionMaker, onUpdate, Project }) => {
  const [formData, setFormData] = useState({
    FirstName: '',
    WorkEmail: '',
    Designation: '',
    status: '',
    remarks: '',
    priority: '',
    TargetCompanyId: '',
    type: '',
  });

  useEffect(() => {
    if (decisionMaker) {
      setFormData({
        FirstName: decisionMaker.FirstName || '',
        WorkEmail: decisionMaker.WorkEmail || '',
        Designation: decisionMaker.Designation || '',
        status: decisionMaker.status || '',
        remarks: decisionMaker.remarks || '',
        priority: decisionMaker.priority || '',
        TargetCompanyId: decisionMaker.TargetCompanyId || '',
        type: decisionMaker.type || '',
      });
    }
  }, [decisionMaker]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCompanyChange = (event, newValue) => {
    setFormData(prev => ({
      ...prev,
      TargetCompanyId: newValue ? newValue.Organization : '',
    }));
  };

  const handleSubmit = async () => {
    try {
      if (onUpdate) {
        await onUpdate(formData);  // 🛠️ Call the update function passed from parent
      }
      onClose(); // 🛠️ Close after saving
    } catch (error) {
      console.error('Error updating decision maker:', error);
    }
  };

  const handleCancel = () => {
    onClose(); // 🛠️ Just close without saving
  };

  const companyOptions = Project?.TargetCompany || [];

  return (
    <Drawer anchor="right" open={open} onClose={handleCancel} PaperProps={{ style: { width: 400 } }}>
      <Box p={3} display="flex" flexDirection="column" height="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Edit Decision Maker</Typography>
          <IconButton onClick={handleCancel}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ my: 2 }} />

        <TextField
          label="First Name"
          name="FirstName"
          value={formData.FirstName}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Work Email"
          name="WorkEmail"
          value={formData.WorkEmail}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          label="Designation"
          name="Designation"
          value={formData.Designation}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Autocomplete
          options={companyOptions}
          getOptionLabel={(option) => option?.Name || ''}
          value={companyOptions.find(c => c.Organization === formData.TargetCompanyId) || null}
          onChange={handleCompanyChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Target Company"
              margin="normal"
              fullWidth
            />
          )}
        />

        <TextField
          label="Type"
          name="type"
          value={formData.type}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          select
          label="Status"
          name="status"
          value={formData.status}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          {statuses.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Remarks"
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          multiline
          rows={3}
          fullWidth
          margin="normal"
        />

        <TextField
          select
          label="Priority"
          name="priority"
          value={formData.priority}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          {priorities.map((priority) => (
            <MenuItem key={priority} value={priority}>
              Priority {priority}
            </MenuItem>
          ))}
        </TextField>

        <Divider sx={{ my: 2 }} />

        <Box mt="auto">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            fullWidth
            sx={{ mb: 2 }}
          >
            Save Changes
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleCancel}
            fullWidth
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default EditSidebar;
